var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_uid.js
// module id = 81
// module chunks = 4